// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"261":"ce37df86","709":"8c45700e","805":"2e3c599a"}[chunkId] + ".js";
};